export class MenuConfig {
	role_id: any;
	organization_type: any;
	asideMenus: any;
	subMenus: any;
	ware_mode: any;
	public default1: any = {
		header: {
			self: {},
			items: [
				// {
				// 	title: 'Dashboards',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/dashboard',
				// 	translate: 'MENU.DASHBOARD',
				// },

			]
		},
		aside: {
			self: {},
			items: [
				{
					roll_id: 1,
					title: 'Dashboard',
					root: true,
					icon: 'fas fa-home',
					page: '/maindashboard'
				},
				{
					roll_id: 1,
					title: 'Manage Subscription',
					root: true,
					icon: 'fas fa-plus-circle',
					page: '/sass_admin/managesubscription'
				},
				{
					roll_id: 1,
					title: 'Package Plan',
					root: true,
					bullet: 'dot',
					icon: 'fa fa-list-ul',
					translate: 'MENU.PACKAGE_PLAN',
					page: '/sass_admin/packageplan'
				},

			]
		},
	};
	public default2: any = {
		header: {
			self: {},
			items: [
				// {
				// 	title: 'Dashboards',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/dashboard',
				// 	translate: 'MENU.DASHBOARD',
				// },

			]
		},
		aside: {
			self: {},
			items: [
				{
					title: 'Dashboard',
					root: true,
					icon: 'fas fa-home',
					page: '/maindashboard',
					translate: 'MENU.DASHBOARD',
					bullet: 'dot',
				},
				{
					title: 'Product Master',
					root: true,
					icon: 'flaticon2-box',
					translate: 'MENU.PRODUCT_MASTER',
					page: '/productmaster'
				},
				{
					title: 'User Management',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-user',
					translate: 'MENU.USER',
					page: '/user'

				},
				{
					title: 'Customer Management',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-user-friends',
					translate: 'MENU.CUSTOMERMANAGEMENT',
					page: '/ad_sd/customermanagement'
				},
				{
					title: 'SLA Mapping',
					root: true,
					bullet: 'dot',
					icon: 'fa fa-map-signs',
					translate: 'MENU.SLA_MAPPING',
					page: '/ad_ma/sla'
				},
				// {
				// 	title: 'Billing-Details',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fas fa-dollar-sign',
				// 	translate: 'MENU.BILLING_DETAILS',
				// 	page: '/billing-detail'
				// },
				{
					title: 'Contract type',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-file-contract',
					translate: 'AMC.TITLE',
					page: '/amc'
				},
				{
					title: 'Contract Price Master',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-file-contract',
					translate: 'MENU.PRICE',
					page: '/contract_price'
				},
				{
					title: 'Service Group',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-layer-group',
					translate: 'MENU.SERVICE',
					page: '/servicegroup'
				},
				// {
				// 	title: 'Model Master',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fas fa-layer-group',
				// 	translate: 'MENU.MENU',
				// 	page: '/model'
				// },
				// {
				// 	title: 'Location mapping',
				// 	root: true,
				// 	icon: 'flaticon2-architecture-and-city',
				// 	page: '/locationmapping',
				// 	translate: 'MENU.LOCATION',
				// 	bullet: 'dot',
				// },				

				{
					title: 'Warehouse Master',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-warehouse',
					translate: 'MENU.WAREHOUSE',
					page: '/warehouse'
				},
				// {
				// 	title: 'Inventory Management',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fas fa-cubes',
				// 	translate: 'MENU.SPARE',
				// 	page: '/spares'
				// },
				{
					title: 'Content Management',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-envelope-open-text',
					translate: 'MENU.CONTENT',
					page: '/content'
				},
				{
					title: 'Settings',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-cog',
					submenu: [
						// {
						// 	title: ' Site Settings',
						// 	root: true,
						// 	bullet: 'dot',
						// 	icon: 'fas fa-user-cog',
						// 	translate: 'MENU.SITE',
						// 	page: '/sitesettings'
						// },
						{
							title: ' SMS Settings',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-sms',
							translate: 'MENU.SMS',
							page: '/sms'
						},
						{
							title: ' SMTP Settings',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-sliders-h',
							translate: 'MENU.SMTP',
							page: '/smtp'
						},
						{
							title: 'Organization Structure',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-sitemap',
							translate: 'MENU.ORG_STR',
							page: '/org'
						},
						{
							title: 'Location',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-map-marker-alt',
							translate: 'MENU.LOCATION',
							page: '/location'
						},
					]
				},
			]
		},
	};
	// public default3: any = {
	// 	header: {
	// 		self: {},
	// 		items: [
	// 			// {
	// 			// 	title: 'Dashboards',
	// 			// 	root: true,
	// 			// 	alignment: 'left',
	// 			// 	page: '/dashboard',
	// 			// 	translate: 'MENU.DASHBOARD',
	// 			// },

	// 		]
	// 	},
	// 	aside: {
	// 		self: {},
	// 		items: [
	// 			{
	// 				title: 'Dashboard',
	// 				root: true,
	// 				alignment: 'left',
	// 				page: '/dashboard',
	// 				translate: 'MENU.DASHBOARD',
	// 				icon: 'fas fa-home',

	// 			},

	// 			{

	// 				title: 'User Management',
	// 				root: true,
	// 				bullet: 'dot',
	// 				icon: 'fas fa-user',
	// 				translate: 'MENU.USER',
	// 				page: '/user'

	// 			},
	// 			// {
	// 			// 	roll_id: 3,
	// 			// 	title: 'Inventory Management',
	// 			// 	root: true,
	// 			// 	bullet: 'dot',
	// 			// 	icon: 'fas fa-cubes',
	// 			// 	translate: 'MENU.SPARE',
	// 			// 	page: '/spares'
	// 			// },


	// 		]
	// 	},
	// };
	public default4: any = {
		header: {
			self: {},
			items: [
				// {
				// 	title: 'Dashboards',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/dashboard',
				// 	translate: 'MENU.DASHBOARD',
				// },

			]
		},
		aside: {
			self: {},
			items: [
				{
					title: 'Dashboard',
					root: true,
					alignment: 'left',
					page: '/servicedesk/service_dashboard',
					icon: 'fas fa-home',
					translate: 'MENU.DASHBOARD'
				},
				{
					title: 'Customer Management',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-user-friends',
					translate: 'MENU.CUSTOMERMANAGEMENT',
					page: '/ad_sd/customermanagement'
				},
				{
					title: 'All Tickets',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-plus-circle',
					translate: 'MENU.ALL',
					page: '/ma_sd/allticket'
				},
				{
					title: 'New Ticket',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-plus-circle',
					translate: 'MENU.NEWTCKT',
					page: '/servicedesk/newticket'
				},
				{
					title: 'Ongoing Ticket',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-circle-notch',
					// translate: 'MENU.NEWTCKT',
					page: '/servicedesk/ongoingticket'
				},

				{
					title: 'Completed Ticket',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-check-circle',
					// translate: 'MENU.NEWTCKT',
					page: '/servicedesk/completedticket'
				},

				{
					title: 'Raise Ticket',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-tasks',
					translate: 'MENU.RAISETCKT',
					page: '/servicedesk/raiseticket'
				},
		

				{
					title: 'Contract Renewal',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-file-contract',
					translate: 'MENU.AMC',
					page: '/servicedesk/amc_contract'
				},


			]
		},
	};
	public default5: any = {
		header: {
			self: {},
			items: [
				// {
				// 	title: 'Dashboards',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/dashboard',
				// 	translate: 'MENU.DASHBOARD',
				// },

			]
		},
		aside: {
			self: {},
			items: [
				{
					title: 'Dashboard',
					root: true,
					alignment: 'left',
					page: '/manager/manager_dashboard',
					translate: 'MENU.DASHBOARD',
					icon: 'fas fa-home'

				},
				{
					title: 'Leaderboard',
					root: true,
					alignment: 'left',
					page: '/manager/leaderboard',
					translate: 'MENU.LEADERBOARD',
					icon: 'fas fa-trophy'

				},
				{
					title: 'All Tickets',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-plus-circle',
					translate: 'MENU.ALL',
					page: '/ma_sd/allticket'
				},
				{
					title: 'Manage Tickets',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-clipboard-list',
					submenu: [
						{
							title: 'New Ticket',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-plus-circle',
							translate: 'MENU.NEWTCKT',
							page: '/manager/manager_newticket'
						},
						{
							title: 'Ongoing Ticket',
							root: true,
							bullet: 'dot',
							icon: 'flaticon-coins',
							translate: 'MENU.NEWTCKT',
							page: '/manager/manager_ongoingticket'
						},
						{
							title: 'Completed Tickets',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-check-circle',
							translate: 'MENU.COMPLETEDTKT',
							page: '/manager/manager_completedtickets'
						},
						{
							title: 'Discount Price Approval',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-check-circle',
							translate: 'MENU.DISCOUNTAPPROVE',
							page: '/manager/discount_approve'
						},
					]
				},
				{
					roll_id: 2,
					title: 'SLA Mapping',
					root: true,
					bullet: 'dot',
					icon: 'fa fa-map-signs',
					translate: 'MENU.SLA_MAPPING',
					page: '/ad_ma/sla'
				},
				{
					title: 'Spare Request',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-toolbox',
					submenu: [
						{

							title: 'Ticket Spare Request',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-tools',
							translate: 'MENU.SPARE',
							page: '/manager/spare_request'
						},
						{

							title: 'Imprest Spare Request',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-hand-holding',
							translate: 'MENU.IMPRESTSPARE',
							page: '/manager/imprest_spare'
						},
						{

							title: 'Spare Transfer Request',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-exchange-alt',
							translate: 'MENU.TRANSFERSPARE',
							page: '/manager/transfer_spare',

						},
					]
				},
				{
					title: 'Knowledge Base',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-brain',
					translate: 'MENU.KNOWLEDGE',
					page: '/manager/knowledgebase'
				},
				{

					title: 'New Contract ',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-file-signature',
					// translate: 'MENU.SPARE',
					page: '/manager/manager_contract'
				},
				{

					title: 'Training Score ',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-star',
					translate: 'MENU.TRAININGSCORE',
					page: '/manager/training_score'
				},
				// {
				// 	title: 'Settings',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fas fa-cog',
				// 	submenu: [
				// 		{

				// 			title: 'Performance matrix ',
				// 			root: true,
				// 			bullet: 'dot',
				// 			icon: 'fas fa-chart-bar',
				// 			translate: 'MENU.PERFORMANCEMATRIX',
				// 			page: '/performance_matrix'
				// 		},
				// 		{
				// 			title: 'Configuration',
				// 			root: true,
				// 			bullet: 'dot',
				// 			icon: 'fas fa-cogs',
				// 			translate: 'MENU.CONFIG',
				// 			page: '/configuration'
				// 		},
				// 	]
				// },


				{
					title: 'Reimbursement',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-hand-holding-usd',
					translate: 'MENU.REIM',
					page: '/manager/reimbursement'
				},
				{
					title: 'Reports',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-infographic',
					submenu: [
						{
							title: 'Attendance report',
							root: true,
							// bullet: 'dot',
							icon: 'fas fa-calendar-check',
							page: '/reports/manager_attendance'
						},
						{
							title: 'Revenue report',
							root: true,
							// bullet: 'dot',
							icon: 'fas fa-hand-holding-usd',
							// translate: 'MENU.SPARE',
							page: '/reports/manager_revenue'
						},
						{

							title: 'Productivity report',
							root: true,
							// bullet: 'dot',
							icon: 'fas fa-chart-line',
							// translate: 'MENU.SPARE',
							page: '/reports/manager_productivity'
						},
						{

							title: 'C-Sat report',
							root: true,
							// bullet: 'dot',
							icon: 'fas fa-calendar-check',
							translate: 'MENU.CSAT',
							page: '/reports/manager_sat'
						},
						{

							title: 'Call Report',
							root: true,
							// bullet: 'dot',
							icon: 'fas fa-phone-square-alt',
							// translate: 'MENU.SPARE',
							page: '/reports/manager_call'
						},
						{

							title: 'Spare Report',
							root: true,
							// bullet: 'dot',
							icon: 'fas fa-tools',
							// translate: 'MENU.SPARE',
							page: '/reports/manager_spare'
						},
						{

							title: 'Expired Contract Report',
							root: true,
							// bullet: 'dot',
							icon: 'fas fa-file-signature',
							// translate: 'MENU.SPARE',
							page: '/reports/contract_expiry_report'
						},
						{

							title: 'Summary Report',
							root: true,
							// bullet: 'dot',
							icon: 'fas fa-clipboard-list',
							// translate: 'MENU.SPARE',
							page: '/reports/manager_summary'
						},
						{
							title: 'FRM Report',
							root: true,
							// bullet: 'dot',
							icon: 'fa fa-list-ul',
							// translate: 'MENU.SPARE',
							page: '/reports/manager_frm'
						},
						{
							title: 'Technician Report',
							root: true,
							// bullet: 'dot',
							icon: 'fa fa-list-ul',
							// translate: 'MENU.SPARE',
							page: '/reports/manager_technicianreport'
						},

					]
				},
				{
					title: 'Technician Tracking',
					root: true,
					// bullet: 'dot',
					icon: 'fa fa-list-ul',
					// translate: 'MENU.SPARE',
					page: '/manager/manager_tracking'
				},
				// {
				// 	title: 'Reports',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'flaticon2-infographic',								
				// 	// translate: 'MENU.AMC',
				// 	page: '/reports'
				// },
				// {

				// 	title: 'Attendance report',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fas fa-calendar-check',
				// 	// translate: 'MENU.SPARE',
				// 	page: '/manager/attendance'
				// },
				// {

				// 	title: 'Revenue report',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fas fa-calendar-check',
				// 	// translate: 'MENU.SPARE',
				// 	page: '/manager/revenue'
				// },
				// {

				// 	title: 'Productivity report',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fas fa-calendar-check',
				// 	// translate: 'MENU.SPARE',
				// 	page: '/manager/productivity'
				// },
				// {

				// 	title: 'C-Sat report',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fas fa-calendar-check',
				// 	translate: 'MENU.CSAT',
				// 	page: '/manager/sat'
				// },
				// {

				// 	title: 'Call Report',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fas fa-phone-square-alt',
				// 	// translate: 'MENU.SPARE',
				// 	page: '/manager/call'
				// },
				// {

				// 	title: 'Spare Report',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fa fa-list-ul',
				// 	// translate: 'MENU.SPARE',
				// 	page: '/manager/spare'
				// },
				// {

				// 	title: 'Summary Report',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fas fa-clipboard-list',
				// 	// translate: 'MENU.SPARE',
				// 	page: '/manager/summary'
				// },
				// {

				// 	title: 'FRM Report',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fa fa-list-ul',
				// 	// translate: 'MENU.SPARE',
				// 	page: '/manager/frm'
				// },
				// {

				// 	title: 'Technician Report',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fa fa-list-ul',
				// 	// translate: 'MENU.SPARE',
				// 	page: '/manager/technicianreport'
				// },



			]
		},
	};
	public default6: any = {
		header: {
			self: {},
		},
		aside: {
			self: {},
			items: [
				{
					title: 'Raise Ticket',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-tasks',
					translate: 'MENU.RAISETCKT',
					page: '/servicedesk/raiseticket'
				},
				{
					title: 'Summary Report',
					root: true,
					// bullet: 'dot',
					icon: 'fas fa-clipboard-list',
					// translate: 'MENU.SPARE',
					page: '/reports/manager_summary'
				},

			]
		},
	};
	public default7: any = {
		header: {
			self: {},
			items: [
				// {
				// 	title: 'Dashboards',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/dashboard',
				// 	translate: 'MENU.DASHBOARD',
				// },

			]
		},
		aside: {
			self: {},
			items: [
				{
					title: 'Dashboard',
					root: true,
					icon: 'fas fa-home',
					page: '/admin/maindashboard',
					translate: 'MENU.DASHBOARD',
					bullet: 'dot',
				},
				{
					title: 'Master Management ',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-envelope-open-text',
					submenu: [
                        {
							title: 'Region Master',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-globe',
							translate: 'MENU.REGION',
							page: '/admin/region'
						},
						{
							title: 'Product Master',
							root: true,
							icon: 'flaticon2-box',
							translate: 'MENU.PRODUCT_MASTER',
							page: '/admin/productmaster'
						},	
						{
							title: 'Model Master',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-sitemap',
							translate: 'MENU.MENU',
							page: '/admin/model'
						},
						{
							title: 'Contract Master',
							root: true,
							bullet: 'dot',
							icon: ' fas fa-clipboard',
							translate: 'MENU.AMC',
							page: '/admin/amc'
						},
						{
							title: 'Support Scope Master',
							root: true,
							bullet: 'dot',
							icon: ' fas fa-file-contract',
							translate: 'MENU.MENU',
							page: '/admin/support-scope'
						},
						{
							title: 'Contract Price Master',
							root: true,
							bullet: 'dot',
							icon: '	fas fa-rupee-sign',
							translate: 'MENU.PRICE',
							page: '/admin/contract_price'
						},
						{
							title: 'Service Group',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-layer-group',
							translate: 'MENU.SERVICE',
							page: '/admin/servicegroup'
						},
				// 		{
				// 			title: 'Town',
				// 			root: true,
				// 			bullet: 'dot',
				// 			icon: 'fas fa-map-marker-alt',
				// 			translate: 'MENU.LOCATION',
				// 			page: '/location'
				// 		},
						{
							title: 'Warehouse Master',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-warehouse',
							translate: 'MENU.WAREHOUSE',
							page: '/admin/warehouse'
						},
				// 		{
				// 			title: 'Spare Master',
				// 			root: true,
				// 			bullet: 'dot',
				// 			icon: 'fas fa-cubes',
				// 			translate: 'MENU.SPARE',
				// 			page: '/spare-master'

				// 		}
					]
				},
				// {
				// 	title: 'Product Master',
				// 	root: true,
				// 	icon: 'flaticon2-box',
				// 	translate: 'MENU.PRODUCT_MASTER',
				// 	page: '/productmaster'
				// },
				{
					title: 'User Management',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-user',
					translate: 'MENU.USER',
					page: '/admin/user'

				},
				{
					title: 'Customer Management',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-user-friends',
					translate: 'MENU.CUSTOMERMANAGEMENT',
					page: '/ad_sd/customermanagement'
				},
				{
					title: 'SLA Mapping',
					root: true,
					bullet: 'dot',
					icon: 'fa fa-map-signs',
					translate: 'MENU.SLA_MAPPING',
					page: '/ad_ma/sla'
				},
				// {
				// 	title: 'Spare',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fa fa-map-signs',
				// 	translate: 'MENU.SLA_MAPPING',
				// 	page: '/spare-master'
				// },
			
				// {
				// 	title: 'Billing-Details',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fas fa-dollar-sign',
				// 	translate: 'MENU.DASHBOARD',
				// 	page: '/billing-detail'
				// },
			
				
				// {
				// 	title: 'Location mapping',
				// 	root: true,
				// 	icon: 'flaticon2-architecture-and-city',
				// 	page: '/locationmapping',
				// 	translate: 'MENU.LOCATION',
				// 	bullet: 'dot',
				// },				

				// {
				// 	title: 'Warehouse Master',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fas fa-warehouse',
				// 	translate: 'MENU.WAREHOUSE',
				// 	page: '/warehouse'
				// },
				// {
				// 	title: 'Inventory Management',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fas fa-cubes',
				// 	translate: 'MENU.SPARE',
				// 	page: '/spares'
				// },
				{
					title: 'Content Management',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-envelope-open-text',
					translate: 'MENU.CONTENT',
					page: '/admin/content'
				},
				{

					title: 'Stock Statement',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-chart-pie',
					// translate: 'MENU.SPARE',
					page: '/ad_wh/stock_statement'
				},
				{
					title: 'Settings',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-cog',
					submenu: [
						// {
						// 	title: ' Site Settings',
						// 	root: true,
						// 	bullet: 'dot',
						// 	icon: 'fas fa-user-cog',
						// 	translate: 'MENU.SITE',
						// 	page: '/sitesettings'
						// },
						{
							title: ' SMS Settings',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-sms',
							translate: 'MENU.SMS',
							page: '/admin/sms'
						},
						{
							title: ' SMTP Settings',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-sliders-h',
							translate: 'MENU.SMTP',
							page: '/admin/smtp'
						},
						

						{
							title: 'Location',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-map-marker-alt',
							translate: 'MENU.LOCATION',
							page: '/admin/location'
						},
						{

							title: 'Performance Metrix ',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-chart-bar',
							translate: 'MENU.PERFORMANCEMATRIX',
							page: '/admin/performance_matrix'
						},
						{
							title: 'Configuration',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-cogs',
							translate: 'MENU.CONFIG',
							page: '/admin/configuration'
						},
					]
				},
			]
		},
	};

	public default8: any = {
		header: {
			self: {},
			items: [
				// {
				// 	title: 'Dashboards',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/dashboard',
				// 	translate: 'MENU.DASHBOARD',
				// },

			]
		},
		aside: {
			self: {},
			items: [
				{
					title: 'Dashboard',
					root: true,
					icon: 'fas fa-home',
					page: '/warehouse/ware_dashboard',
					translate: 'MENU.DASHBOARD',
					bullet: 'dot',
				},
				{
					title: 'Spare Master',
					root: true,
					bullet: 'dot',
					icon: 'fa fa-map-signs',
					translate: 'MENU.SLA_MAPPING',
					page: '/warehouse/spare-master'
				},

				{
					title: 'Update Inventory',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-cubes',
					translate: 'MENU.SPARE',
					page: '/warehouse/spares'
				},
				{

					title: 'Manage Indent',
					root: true,
					bullet: 'dot',
					icon: 'fa fa-indent',
					translate: 'MENU.SPARE',
					page: '/warehouse/manageindent',
					submenu: [
						// if(this.ware_mode == 1){
							
                        // }						
					   
						{
							title: 'Raise Consolidated Indent',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-clipboard-list',
							translate: 'MENU.SMS',
							page: '/warehouse/raise_consolidated_indent'
						},
						{
							title: 'Track Indent',
							root: true,
							bullet: 'dot',
							icon: 'fas fa-truck-pickup',
							translate: 'MENU.SMS',
							page: '/warehouse/track_indent'
						},
					]
				},
				{

					title: 'Track Spare Request',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-route',
					translate: 'MENU.SPARE',
					page: '/warehouse/service_spare_request'
				},
				{

					title: 'Stock Statement',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-chart-pie',
					// translate: 'MENU.SPARE',
					page: '/ad_wh/stock_statement'
				},
				{

					title: 'FRM Update ',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-coins',
					translate: 'MENU.SPARE',
					// icon: 'fas fa-repeat',
					// translate: 'MENU.SPARE',
					page: '/warehouse/frm-status-update'
				},

				{

					title: 'FRM Stock Statement',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-file-alt',
					// translate: 'MENU.IMPRESTSPARE',
					page: '/warehouse/frm_stock_statement'
				},
				// {

				// 	title: 'Spare Transfer Request',
				// 	root: true,
				// 	bullet: 'dot',
				// 	icon: 'fas fa-exchange-alt',
				// 	translate: 'MENU.TRANSFERSPARE',
				// 	page: '/transfer_spare',

				// },

			]
		},
	};
	public default9: any = {
		header: {
			self: {},
			items: [
				// {
				// 	title: 'Dashboards',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/dashboard',
				// 	translate: 'MENU.DASHBOARD',
				// },

			]
		},
		aside: {
			self: {},
			items: [
				{
					title: 'TRC Update',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-tools',
					translate: 'MENU.TRC',
					page: '/trc/trc_update'
				},
			

			]
		},
	};
	central_ware: { title: string; root: boolean; bullet: string; icon: string; translate: string; page: string; };
	

	public get configs(): any {
		this.role_id = localStorage.getItem('pro_role_id');
		console.log(this.role_id);
		this.organization_type = localStorage.getItem('pro_organization_type');
		console.log(this.organization_type)
		if (this.role_id == 1) {
			return this.default1;
		}
		else if (this.role_id == 2) {
			if (this.organization_type == 1) {
				console.log("Centralized admin");
				this.asideMenus = localStorage.getItem('pro_asideMenus');
				console.log(this.default7);
				return this.default7;
			}
			else {
				console.log("Centralized admin");
				this.asideMenus = localStorage.getItem('pro_asideMenus');
				console.log(this.default2);
				return this.default2;
			}

		}
		// else if (this.role_id == 3) {
		// 	return this.default3;
		// }
		else if (this.role_id == 4) {
			// localStorage.removeItem('asideMenus');
			var menus = this.default4.aside.items;
			console.log(menus);
			localStorage.setItem('pro_asideMenus', JSON.stringify(menus));
			this.asideMenus = localStorage.getItem('pro_asideMenus');
			this.subMenus = localStorage.getItem('pro_submenu');
			console.log(this.subMenus, "subMenu")
			return this.default4;
		}
		else if (this.role_id == 5) {
			// localStorage.removeItem('asideMenus');
			console.log("inside of Manager");
			console.log(this.default5);
			var menus = this.default5.aside.items;
			console.log(menus);
			localStorage.setItem('pro_asideMenus', JSON.stringify(menus));
			this.asideMenus = localStorage.getItem('pro_asideMenus');
			this.subMenus = localStorage.getItem('pro_submenu');
			console.log(this.subMenus, "subMenu")
			console.log(JSON.parse(this.asideMenus));
			return this.default5;
		}
		else if (this.role_id == 7) {
			// localStorage.removeItem('asideMenus');
			console.log("inside of call");
			console.log(this.default6);
			var menus = this.default6.aside.items;
			console.log(menus);
			localStorage.setItem('pro_asideMenus', JSON.stringify(menus));
			this.asideMenus = localStorage.getItem('pro_asideMenus');
			this.subMenus = localStorage.getItem('pro_submenu');
			console.log(this.subMenus, "subMenu")
			console.log(JSON.parse(this.asideMenus));
			return this.default6;
		}
		else if (this.role_id == 9) {
			// localStorage.removeItem('asideMenus');
			console.log("inside of call");
			console.log(this.default8);
			var menus = this.default8.aside.items;
			this.asideMenus = localStorage.getItem('pro_asideMenus');
			this.ware_mode = localStorage.getItem('pro_warehouse_mode')
			if(this.ware_mode == 1){                                                // component for only centralized warehouse mode 
			this.central_ware=	{
					title: 'Indent Allocation',
					root: true,
					bullet: 'dot',
					icon: 'fas fa-solid fa-file ',
					translate: 'MENU.SPARE',
					page: '/manage_spare_indent'
				}
				const vari = this.default8.aside.items.find(v=> v.title === "Manage Indent")          //find the module name 
				vari.submenu.push(this.central_ware)                                                  // push this component in previous array 
			}
			// localStorage.setItem('asideMenus', JSON.stringify(menus));
			// this.asideMenus = localStorage.getItem('asideMenus');
			// this.subMenus = localStorage.getItem('submenu');
			// console.log(this.subMenus, "subMenu")
			// console.log(JSON.parse(this.asideMenus));
			return this.default8;
		}
		else if (this.role_id == 10) {
			// localStorage.removeItem('asideMenus');
			// console.log("inside of call");
			// console.log(this.default8);
			var menus = this.default9.aside.items;
			// console.log(menus);
			this.asideMenus = localStorage.getItem('pro_asideMenus');
			// localStorage.setItem('asideMenus', JSON.stringify(menus));
			// this.asideMenus = localStorage.getItem('asideMenus');
			// this.subMenus = localStorage.getItem('submenu');
			// console.log(this.subMenus, "subMenu")
			// console.log(JSON.parse(this.asideMenus));
			return this.default9;
		}
	}

}
